import { ref, watch } from 'vue'
import { themes, type ThemeType } from '@/config/theme'

export function useThemeConfig() {
  // 从 localStorage 读取主题设置
  const savedTheme = (localStorage.getItem('theme') as ThemeType) || 'default'
  const currentTheme = ref<ThemeType>(savedTheme)

  const updateTheme = (theme: ThemeType) => {
    const root = document.documentElement
    const themeConfig = themes[theme]

    // 更新 CSS 变量
    Object.entries(themeConfig.colors).forEach(([key, value]) => {
      if (typeof value === 'object') {
        Object.entries(value).forEach(([subKey, subValue]) => {
          root.style.setProperty(`--${key}-${subKey}`, subValue)
        })
      } else {
        root.style.setProperty(`--${key}`, value)
      }
    })

    // // 更新渐变
    // Object.entries(themeConfig.gradients).forEach(([key, value]) => {
    //   root.style.setProperty(`--${key}-gradient`, value)
    // })

    // 保存到 localStorage
    localStorage.setItem('theme', theme)
    currentTheme.value = theme
  }

  // 监听主题变化
  watch(currentTheme, updateTheme, { immediate: true })

  return {
    currentTheme,
    updateTheme,
  }
}
